import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Tab, Tabs, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Icon, IconButton, Divider } from '@material-ui/core';
import * as Actions from './store/actions';
import RichTextEditor from 'react-rte';
import * as moment from 'moment';
import _ from 'lodash';
import {parseForFrontend} from './AssignmentContentParse';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class AssignmentPreview extends Component {
    state = {
        preview: '',
        previewLoaded: false
    }

    componentDidMount = () => {
        const { currentAssignment } = this.props;
        this.setState({ previewLoaded: true, preview: parseForFrontend(currentAssignment.header.AssignmentContent, currentAssignment.assetList)})
    }

    render() {
        const { currentAssignment } = this.props;
        if (!this.state.previewLoaded) {
            return (
                <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Typography variant="h5">{currentAssignment.header.AssignmentName}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1">{currentAssignment.header.AssignmentDescription}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div></div>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">Instructor Attachments</Typography>
                        <Divider />
                        {currentAssignment.assetList.map((asset) => {
                            return (
                                <li key={asset.header.asset_id}><a href={asset.header.URL} target="_blank">{asset.header.AssetNewName}</a> {asset.header.OriginalURL ? '  |  ' : null} {asset.header.OriginalURL ? <a href={asset.header.OriginalURL} target="_blank">download powerpoint</a> : null} </li>
                            );
                        })}
                    </Grid>
                </Grid>
            </div>
            )
        }
        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Typography variant="h5">{currentAssignment.header.AssignmentName}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1">{currentAssignment.header.AssignmentDescription}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div dangerouslySetInnerHTML={{__html: this.state.preview}}></div>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1">Instructor Attachments</Typography>
                        <Divider />
                        {currentAssignment.assetList.map((asset) => {
                            return (
                                <li key={asset.header.asset_id}><a href={asset.header.URL} target="_blank">{asset.header.AssetNewName}</a> {asset.header.OriginalURL ? '  |  ' : null} {asset.header.OriginalURL ? <a href={asset.header.OriginalURL} target="_blank">download powerpoint</a> : null} </li>
                            );
                        })}
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ assignmentApp, assetApp, auth }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignmentPreview)));



// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentPreview.js